import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import AuthAPI from '@/api/auth'
import QueueAPI from '@/api/queue'
import CurrencyAPI from '@/api/currency'

import QueueModule from './queue.js'
import PreorderModule from './preorder.js'
import ReserveModule from './reserve.js'
import HotelsModule from './hotels.js'

import moment from 'moment'

export default new Vuex.Store({
    modules: {
        queue: QueueModule,
        preorder: PreorderModule,
        reserve: ReserveModule,
        hotels: HotelsModule
    },
    state: {
        cafe: {},
        waiter: {},
        menu: {},
        region: {},
        currency: {
            code: 'грн.',
            iso_code: 'UAH',
            symbol: '₴'
        },
        intercom_hash: null,
        delivery_settings: {},
        waiting_times: {
            inside: [5, 10, 15],
            preorder: [5, 10, 15],
            delivery: [5, 10, 15],
            hotels: [5, 10, 15]
        },
        notifications: [],

        initialized: false,

        shared: false,

        error: null
    },
    getters: {
        activeModesCount(state) {
            if (!state.cafe.modes) return 0;

            return (
                (!!state.cafe.modes.inside && !state.cafe.inside_lite) +
                !!state.cafe.modes.preorder +
                !!state.cafe.modes.delivery +
                !!state.cafe.modes.hotels
            );
        },
        unreadNotificationsCount(state) {
            return state.notifications.filter(n => !n.is_read).length;
        },
        isHotel(state) {
            return state.cafe.primary_category == 'hotel';
        }
    },
    mutations: {
        setCafe(state, payload) {
            state.cafe = payload;
        },
        setWaiter(state, payload) {
            state.waiter = payload;
        },
        setMenu(state, payload) {
            state.menu = payload;
        },
        setCurrency(state, payload) {
            state.currency = payload;
        },
        setError(state, err) {
            state.error = err;
        },
        setRegion(state, payload) {
            state.region = payload;
        },
        setShared(state, payload) {
            state.shared = payload;
        },
        setInitialized(state) {
            state.initialized = true;
        },
        setDeliverySettings(state, payload) {
            state.delivery_settings = payload;
        },
        setNotifications(state, payload) {
            state.notifications = payload;
        },
        setWaitingTimes(state, payload) {
            state.waiting_times = payload;
        },
        markAllNotificationsRead(state) {
            state.notifications.forEach((notif, index) => {
                Vue.set(state.notifications[index], 'is_read', true);
            });
        },
        setIntercomHash(state, value) {
            state.intercom_hash = value;
        }
    },
    actions: {
        fetchWaiter(context) {
            return new Promise((resolve, reject) => {
                AuthAPI.whoami().then(data => {
                    if (data.session.type == 'shared') {
                        context.commit('setShared', true);
                    } else {
                        context.commit('setShared', false);
                        context.commit('setWaiter', data.session.waiter);
                    }

                    context.commit('setIntercomHash', data.intercom_hash);

                    resolve();
                }).catch(error => {
                    // context.commit('setError', error);
                    reject();
                });
            });
        },
        fetchCurrency(context) {
            return new Promise((resolve, reject) => {
                if (!context.state.cafe.currency_id) return resolve();

                CurrencyAPI.getById(context.state.cafe.currency_id).then(data => {
                    context.commit('setCurrency', data.currency);
                    resolve();
                }).catch(errror => {
                    console.error(error);
                    reject();
                });
            });
        },
        fetchCafeAndMenu(context) {
            return new Promise((resolve, reject) => {
                QueueAPI.getCafe().then(data => {
                    context.commit('setCafe', data.cafe);
                    context.commit('setDeliverySettings', data.delivery_settings);
                    context.commit('setRegion', data.region);
                    context.commit('setWaitingTimes', data.waiting_times);
                    context.dispatch('fetchMenu');
                    context.dispatch('fetchCurrency');
                    resolve();
                }).catch(error => {
                    // context.commit('setError', error);
                    reject();
                });
            });
        },
        fetchMenu(context) {
            return new Promise((resolve, reject) => {
                // if (!context.state.cafe.menu_ids || !context.state.cafe.menu_ids.length) return;

                // const first_menu = context.state.cafe.menu_ids[0];
                QueueAPI.getMenu().then(data => {
                    context.commit('setMenu', data.menu);
                    resolve();
                }).catch(error => {
                    context.commit('setError', error);
                    reject();
                });
            });
        },
        fetchNotifications(context, payload) {
            return new Promise((resolve, reject) => {
                QueueAPI.getNotifications().then(data => {
                    context.commit('setNotifications', data.notifications);
                }).catch(reject);
            });
        },
        markNotificationsRead(context) {
            return new Promise((resolve, reject) => {
                if (!context.getters.unreadNotificationsCount) {
                    resolve();
                    return;
                }

                QueueAPI.markNotificationsRead();
                context.commit('markAllNotificationsRead');
                resolve();
            });
        },
        init(context, payload) {
            return new Promise((resolve, reject) => {
                if (payload && !payload.force && context.state.initialized) {
                    resolve();
                    return;
                }

                Promise.all([
                    context.dispatch('fetchWaiter'),
                    context.dispatch('fetchCafeAndMenu')
                ]).then(ok => {
                    context.commit('setInitialized');

                    // if (context.state.cafe.modes.preorder || context.state.cafe.modes.delivery) {}
                    if (context.state.cafe.modes.preorder || context.state.cafe.modes.delivery) context.dispatch('preorder/fetchPreorders');
                    if (context.state.cafe.modes.inside) context.dispatch('queue/fetchOrders');
                    if (context.state.cafe.modes.reserve) context.dispatch('reserve/fetchReservations');
                    if (context.state.cafe.modes.hotels) context.dispatch('hotels/fetchList');
                    context.dispatch('fetchNotifications');



                    resolve();
                }).catch(err => {
                    reject(err);
                });
            });
        },
        logout(context, payload) {
            AuthAPI.logout();
        },
        bootIntercom(context, {
            isDesktop
        }) {
            const intercomOpts = {};

            const waiter = context.state.waiter;
            const cafe = context.state.cafe;

            intercomOpts.name = waiter.name;
            intercomOpts.user_id = waiter._id;
            intercomOpts.user_hash = context.state.intercom_hash;
            intercomOpts.phone = waiter.phone || '';
            intercomOpts.company = {
                id: cafe.qId,
                internal_id: cafe._id,
                name: cafe.name,
                created_at: moment(cafe.registered).unix(),
                address: cafe.address
            }

            if (!isDesktop) {
                intercomOpts.hide_default_launcher = true;
            }

            window.Intercom("boot", {
                app_id: "rsh7gloh",
                ...intercomOpts
            });
        },  
    }
});